<template>
  <div class="loginDynamicPassPage">
    <job-header-simple :header_title="header_title"></job-header-simple>
    <password-input :value="pass" @input="pass = $event" />
    <password-input :value="pass2" @input="pass2 = $event" placeholder="请再次填写6位以上数字+字母的密码" />
    <van-button type="info" size="large" class="btn" @click="onClickButtonSubmit">确 认</van-button>
    <div class="links" v-if="!isLogin">
      <router-link to="/login">返回登录页</router-link>
    </div>
  </div>
</template>
<script>
import { Button, Field, Toast, Icon } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import passwordInput from "@/components/passwordInput/index.vue";
import {
  setEmployeePassword,
  employeeForgetPassword
} from "@/api/employee/request";
import { passwordValidate } from "@/utils/validate";
import api from "@/api/list";
import { setToken } from "@/utils/auth";
import jwt_decode from "jwt-decode";
import { rsaEncrypt } from "@/utils/rsa";

export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    jobHeaderSimple,
    passwordInput
  },
  data() {
    return {
      header_title: this.$route.params.status == 1 ? "设置密码" : "重置密码",
      pass: "", //第一次填写的密码
      pass2: "", //第二次填写的密码
      isLogin: this.$store.getters.jwtDecode.exp
    };
  },
  methods: {
    goMode() {
      api.getAccountIdntityType().then((res) => {
        if (res.data.status == "200") {
          switch (res.data.data.identityType) {
            // 普通灵活用工
            case "COMMON_EMPLOYEE":
              window.location.href = `${document.location.origin}/index.html#/home`;
              break;
            //个体户用工
            case "INDIVIDUAL_BUSINESSES":
              window.location.href = `${document.location.origin}/index1.html#/home`;
              break;
            //同时具有双重身份
            case "DOUBLE_IDENTITY":
              switch (res.data.data.lastMode){
                // 普通灵活用工
                case 1: 
                  window.location.href = `${document.location.origin}/index.html#/home`;
                  break;
                //个体户用工
                case 2:
                  window.location.href = `${document.location.origin}/index1.html#/home`;
                  break;
                case null:
                  this.$router.push({
                    path: "/individual_choose",
                  });
                  break;
              }
              break;
            default:
              window.location.href = `${document.location.origin}/index.html#/home`;
          }
        }
      });
    },
    //确认按钮
    onClickButtonSubmit() {
      if (this.pass == "") {
        this.$toast("密码不能为空");
        return false;
      }

      if (this.pass2 == "") {
        this.$toast("请再次填写6位以上数字+字母的密码");
        return false;
      } else if (this.pass2 !== this.pass) {
        this.$toast("两次填写的密码必须一致");
        return false;
      }
      if (!passwordValidate(this.pass)) {
        this.$toast("请填写6位以上数字+字母的密码");
        return false;
      }
      let password = rsaEncrypt(this.pass);
      if (
        this.$route.params.status == 1 &&
        typeof this.$route.params.passwordFlag == "undefined"
      ) {
        setEmployeePassword({ password: password }).then(res => {
          if (res.data.status == "200") {
            Toast({
              type: "success",
              forbidClick: true, // 禁用背景点击
              message:
                this.$route.params.status == 1 ? "密码设置成功" : "密码已重置",
              duration: 500,
              onClose: this.goMode()
            });
          } else {
            Toast({
              type: "error",
              message: res.data.message
            });
          }
        });
      } else {
        let query = this.$route.params;
        query.password = password;
        let status = this.$route.params.status;
        if (status == 1) {
          query.username = query.mobile;
          api.forgetPassword(query, { method: "post", subUrl: 1 }).then(res => {
            if (res.data.status == "200") {
              if (res.data.data && typeof res.data.data != "undefined") {
                //debugger
                setToken(res.data.data);
                this.$store.commit("SET_TOKEN", res.data.data);
                this.$store.commit("SET_JWTDECODE", jwt_decode(res.data.data));
                Toast({
                  type: "success",
                  forbidClick: true, // 禁用背景点击
                  message: "密码设置成功",
                  duration: 500,
                  onClose: this.goMode()
                });
              }
            } else {
              Toast({
                type: "error",
                message: res.data.message
              });
            }
          });
        } else {
          employeeForgetPassword(query).then(res => {
            if (res.data.status == "200") {
              Toast({
                type: "success",
                forbidClick: true, // 禁用背景点击
                message:
                  this.$route.params.status == 1
                    ? "密码设置成功"
                    : "密码已重置",
                duration: 500,
                onClose: () => this.$router.push("/login")
              });
            } else {
              Toast({
                type: "error",
                message: res.data.message
              });
            }
          });
        }
      }
    }
  },
  mounted: function() {
    document.getElementsByTagName("body")[0].className = "bg_f";
  },
  beforeDestroy: function() {
    document.body.removeAttribute("class", "bg_f");
  }
};
</script>

<style lang="less" scoped>
.loginDynamicPassPage {
  display: block;
  padding: 44px;

  .links {
    position: fixed;
    left: 0;
    bottom: 90px;
    width: 100%;
    text-align: center;
    a {
      font-size: 13px;
      color: @blue;
    }
  }

  .btn {
    margin-top: 60px;
  }

  .i-text {
    color: @blue;
    font-size: 12px;
  }
}
</style>
<style lang="less">
.loginDynamicPassPage {
  .van-cell {
    margin-bottom: 10px;
    border-radius: 6px;
    padding: 11px 25px;
    background: #f3f3f3;
  }
}
</style>



